import { render, staticRenderFns } from "./tambahpeserta.vue?vue&type=template&id=60fe93b4&"
import script from "./tambahpeserta.vue?vue&type=script&lang=js&"
export * from "./tambahpeserta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports